import { NavLink, Outlet } from 'react-router-dom';
import { LayoutGrid, Link2, ShieldCheck, User } from 'lucide-react';
import { useSession } from '../../auth/authQueries';
import { initials } from '../../lib/formatters';
import { ROUTES } from '../../lib/routes';
import { Brand } from './CenteredCardLayout';
import './layout.css';

const NAV_ITEMS = [
  { to: ROUTES.account, label: 'Tổng quan', end: true, Icon: LayoutGrid },
  { to: ROUTES.profile, label: 'Hồ sơ', end: false, Icon: User },
  { to: ROUTES.connections, label: 'Kết nối', end: false, Icon: Link2 },
  { to: ROUTES.security, label: 'Bảo mật', end: false, Icon: ShieldCheck },
];

/** App shell with sidebar + navigation for /account/* routes (spec §7.1). */
export function AppShell() {
  const session = useSession();
  const displayName =
    (session.data?.authenticated ? session.data.user.displayName : null) ?? 'Người dùng';

  return (
    <div className="app">
      <a className="skip-link" href="#main">
        Bỏ qua đến nội dung chính
      </a>

      <aside className="sidebar">
        <Brand />
        <nav className="sidebar__nav" aria-label="Tài khoản">
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className="navlink">
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="userchip">
          <span className="userchip__avatar" aria-hidden="true">
            {initials(displayName)}
          </span>
          <div className="userchip__meta">
            <span className="userchip__name">{displayName}</span>
            <span className="userchip__status">Đang hoạt động</span>
          </div>
        </div>
      </aside>

      <header className="topbar">
        <Brand />
      </header>

      <main className="main" id="main">
        <div className="main__inner">
          <Outlet />
        </div>
      </main>

      <nav className="bottomnav" aria-label="Tài khoản">
        {NAV_ITEMS.map(({ to, label, end, Icon }) => (
          <NavLink key={to} to={to} end={end} className="bottomnav__item">
            <Icon size={20} aria-hidden="true" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
